import {BrowserRouter, Routes} from "react-router-dom";
import React from "react";
import {RoutingHelper} from "./components/Navigation/Routing";

function AppRouter() {
    if (window.location.pathname === '/fr' || window.location.pathname.includes('/fr/')) {
        window.location.pathname = '/';
    }

    return (
        <BrowserRouter>
            <Routes>
                {RoutingHelper.getRoutes().map((route, index) => (
                    RoutingHelper.createRouteElement(route, index)
                ))}
            </Routes>
        </BrowserRouter>
    );
}

export default AppRouter;
